export default function ModelesSaisiesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('modeles.saisies');
}

ModelesSaisiesConfiguration.$inject = ['$translatePartialLoaderProvider'];
